import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const TermsCondition = () => {
  const [loading, setLoading] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const data = localStorage.getItem("userInfo");
        if (data) {
          // Optionally use user info
        }
      } catch (error) {
        console.error("Error retrieving user info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  const handleAccept = () => {
    if (isAgreed) {
      navigate("/SignUp");
    } else {
      toast.error("You must agree to the terms and conditions.");
    }
  };

  const handleDecline = () => {
    try {
      localStorage.clear();
      toast.success("You have declined the terms and conditions.");
      navigate("/CustomerLogin");
    } catch (error) {
      console.error("Error clearing localStorage:", error);
      toast.error("Failed to clear user data. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-secondary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: '700px' }}>
      <div className="mb-4">
        <h2 className="fw-semibold text-dark">Terms of Use</h2>
        <h5 className="mt-4 fw-semibold text-dark">Know Your Rights & Responsibilities</h5>
        <p className="text-muted small">Last Updated: February 6, 2025</p>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Welcome to Xgo Life! These Terms of Use (“Terms”) govern your use of the Xgo Life mobile applications, websites, products, content, facilities, and platform (collectively, the “Platform”). By confirming your acceptance of these Terms or using the Platform, you enter into a legally binding contract with us.
        </p>
        <h5 className="mt-4 fw-semibold text-dark">Scope of Agreement and Services</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Xgo Life operates as a technology platform that connects users with independent service providers, including drivers, virtual stores, transport logistics, and delivery partners. Customers can shop online from independent stores, and their goods are delivered by independent couriers. Please note that we do not provide transportation, delivery, or retail services directly. All services are provided by independent contractors (“Couriers”) and independent stores (“Clients”), who operate under their own terms. Clients can request delivery services and offer their price, which Couriers can accept or counteroffer. A separate agreement is formed between the Courier and the Client upon confirmation of the transportation or delivery service. The decision to engage with these services is made at your own risk, as the Platform solely facilitates the connection and payment between Clients, Drivers, and virtual stores.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Acceptance of Terms</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          By using the Platform, you acknowledge that you have read and understand these Terms, our Privacy Policy, and any supplemental terms that may apply to specific services. If you are accepting these Terms on behalf of an entity, you represent that you have the authority to bind that entity.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Account Registration</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          To access the functionality of the Platform, you must create an account. You must be at least 18 years old and provide accurate and up-to-date information. You are responsible for maintaining the confidentiality of your account details and will be liable for all activities that occur under your account. If you use the Platform in a different country, you agree to comply with the local terms applicable to that region.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">User-Provided Content</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You are responsible for any information, files, and images (“Content”) that you make available on the Platform. You must ensure that your Content does not violate any laws or rights of others. Xgo Life reserves the right to remove or restrict access to any Content that we reasonably believe violates these Terms. By submitting Content, you grant Xgo Life a perpetual, irrevocable, worldwide, and non-exclusive license to use, reproduce, publish, and display your Content for the purpose of operating and improving the Platform.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Driver and Delivery Partner Responsibilities</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          All drivers and delivery partners are independent contractors, not employees of Xgo Life. They are responsible for the safety and timely delivery of passengers and packages and must comply with local safety and operational regulations.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Client’s Responsibility</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          As a Client, you are responsible for providing accurate information about the delivery, ensuring unhindered access for the Courier, and safeguarding the Parcel’s packaging and legality. You must also not send Parcels exceeding specified weight limits and ensure all items are lawfully acquired.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Payment Transactions</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Clients can make offers to Drivers for rides and courier services. When a Driver accepts an offer, a contract is formed between the Driver and Client. Payments for Services are due immediately and processed through the Platform. You are responsible for paying all fees, including applicable taxes and waiting fees, as outlined in the Platform. Refunds may apply under specific conditions, as detailed in our Refund Policy.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Data Privacy</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Your privacy is important to us. Our data collection and use practices are outlined in our separate Privacy Policy. By using the Platform, you consent to the collection, use, and sharing of your information as described in the Privacy Policy.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Restricted Activities</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You are prohibited from engaging in the following activities while using the Platform:
          <ul>
            <li>Infringing on any third-party rights, including intellectual property rights.</li>
            <li>Using the Platform for any unlawful purpose or in violation of these Terms.</li>
            <li>Engaging in fraud, harassment, or any behavior that may damage the reputation of Xgo Life.</li>
          </ul>
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Suspension or Termination of Access</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Xgo Life reserves the right to suspend or terminate your access to the Platform for any reason, including violations of these Terms. Inactive accounts may be deleted after three years.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Cooperation with Law Enforcement</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          We may cooperate with law enforcement authorities in investigating violations of these Terms. We reserve the right to monitor your use of the Platform and take action as necessary.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Eligibility</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          To use our Platform, you must be at least 18 years old and possess the legal authority to enter into a binding contract.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Modification of Terms</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          We may update these Terms at any time, and changes will take effect as of the date specified at the top of this document. Continued use of the Platform following updates constitutes your acceptance of the new Terms.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">License and Intellectual Property</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          We grant you a limited, non-exclusive, non-transferable license to access and use the Platform for personal, non-commercial purposes. All content within the Platform is owned by us or our licensors and is protected by applicable intellectual property laws.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">User Conduct</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You agree to use the Platform in accordance with all applicable laws and regulations. You must not engage in any activities that could harm other users or disrupt the services provided through the Platform.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Payment Terms</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Clients will pay the agreed-upon price for services rendered by drivers or delivery partners through the Platform. All payments will include applicable taxes and fees.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Payment Method</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You must provide valid payment information and authorize us to charge your designated payment method for all transactions.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Cancellation Fees</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          If you cancel a ride or delivery after a certain period, you may incur a cancellation fee, which will be communicated to you at the time of cancellation.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Assignment</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You may not assign or transfer these Terms, in whole or in part, without prior written approval from Xgo Life. You grant us the right to assign or transfer these Terms, including to:
          <ul>
            <li>A subsidiary or affiliate.</li>
            <li>An acquirer of our business or assets.</li>
            <li>A successor by merger.</li>
          </ul>
          No joint venture, partnership, employment, or agency relationship exists between you and Xgo Life or any third-party provider as a result of using the Platform.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Force Majeure</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Neither party shall be liable for any failure to perform its obligations under these Terms if such failure results from any cause beyond that party’s reasonable control, including, but not limited to, mechanical, electronic, or communications failure or degradation.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Notification of Force Majeure</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          In the event of a force majeure occurrence, the affected party will notify the other party as soon as reasonably practicable, outlining the nature of the force majeure and its expected duration.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Indemnification</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          You agree to indemnify and hold Xgo Life, its affiliates, and their respective officers, employees, and agents harmless from any claims, losses, liabilities, damages, costs, and expenses (including reasonable attorneys’ fees) arising out of your use of the Platform or violation of these Terms.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Limitation of Liability</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          To the maximum extent permitted by law, Xgo Life will not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Platform, even if we have been advised of the possibility of such damages.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Governing Law</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction where Xgo Life is incorporated, without regard to its conflict of law principles.
        </p>

        <h5 className="mt-4 fw-semibold text-dark">Contact Us</h5>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          For any questions or support, please contact us at:
        </p>
        <p className="text-secondary" style={{ lineHeight: '1.6' }}>
          Email: info@xgolife.com<br />
          Phone: +263773406449, +263777304942
        </p>
      </div>

      <div className="form-check my-4">
        <input 
          type="checkbox" 
          className="form-check-input" 
          id="agreeCheck"
          checked={isAgreed} 
          onChange={() => setIsAgreed(!isAgreed)} 
        />
        <label className="form-check-label text-dark" htmlFor="agreeCheck">
          I have read and agree to the terms and conditions.
        </label>
      </div>

      <div className="d-flex justify-content-between gap-3">
        <button 
          className="btn w-100"
          style={{
            backgroundColor: isAgreed ? '#000' : '#ccc',
            color: '#fff',
            borderRadius: '10px',
            transition: 'background-color 0.3s ease'
          }}
          onClick={handleAccept}
          disabled={!isAgreed}
        >
          Accept
        </button>
        <button 
          className="btn w-100"
          style={{
            backgroundColor: '#f2f2f7',
            color: '#000',
            borderRadius: '10px',
            border: '1px solid #ccc',
            transition: 'background-color 0.3s ease'
          }}
          onClick={handleDecline}
        >
          Decline
        </button>
      </div>

      <ToastContainer position="bottom-center" />
    </div>
  );
};

export default TermsCondition;